import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"
import { Column, Row, RowCenter } from "style/preset"
import { CommonSwitchBtnCom } from "components/SwitchBtnCom"
import { ListBottomGradientWrap, ListTopGradientWrap, ScrollBoxWrap } from "components/Drawer/DrawerStyle"

import ticketBgImg from 'assets/images/ticket_bg.png'
import { ReactComponent as AddNewSvg } from 'assets/svgs/add_news.svg'
import { ReactComponent as TicketIconSvg } from 'assets/svgs/icon_ticket.svg'
import { ReactComponent as PendingIconSvg } from 'assets/svgs/pending_icon.svg'
import { ReactComponent as RightIconSvg } from 'assets/svgs/right_icon.svg'
import { ReactComponent as CommentSvg } from 'assets/svgs/comments.svg'
import { useCallback, useEffect, useState } from "react"
import { HashHandlerItem } from "pages/Orders"
import CImage from "components/CImage"
import DrawerNewTicketCom from "components/Drawer/DrawerNewTicketCom"
import useTickets from "hooks/useTickets"
import { getIconUrl, shortStr } from "utils"
import { useAppDispatch, useAppSelector } from "hooks/redux/hooks"
import { setOpenNewTicketWin } from "hooks/redux/slices/appSlice"


const TicketsPage = () => {
  const { chains, openNewTicketWin } = useAppSelector((state) => state.app)
  const { ticketList, updateFilter, getTicketList } = useTickets()
  const dispatch = useAppDispatch()
  const [tabIndex, setTabIndex] = useState(0)

  useEffect(() => {
    let filterVal = 'Unknown'
    if(tabIndex === 0) {
      filterVal = 'Unknown'
    } else if(tabIndex === 1) {
      filterVal = 'Pending'
    } else {
      filterVal = 'Succeeded'
    }
    updateFilter(filterVal)
  }, [tabIndex, updateFilter])

  useEffect(() => {
    getTicketList()
  }, [getTicketList])

  const getStatusIcon = useCallback((status: string) => {
      if(status === 'pending') {
          return <PendingIconSvgWrap></PendingIconSvgWrap>
      } else {
          return <RightIconSvgWrap></RightIconSvgWrap>
      }
  }, [])

  const getChainInfo = useCallback((chainName: string) => {
    const curChain = chains.find(item => item.nickName === chainName)
    if(curChain) {
      return {
        fullName: curChain.fullName,
        imgUrl: getIconUrl(curChain.chainIndex, 'chain', 'solid')
      }
    } else {
      return {
        fullName: chainName,
        imgUrl: ''
      }
    }
  }, [chains])

  return <TicketsPageWrap>
      <EmptyColumn></EmptyColumn>
      <OutWrap>
        <TicketHeaderWrap>
          <StyledContainer $fontSize="22px" $lineHeight="22px" $fontWeight6 $roobertSemiBold>Chainge Support</StyledContainer>
          <StyledContainer $mt="8px" $fontSize="14px" $lineHeight="18px" $fontWeight4 $roobertRegular $color="#767A7F">The easiest way to report transaction-related issues</StyledContainer>
          <Row $justifyContent="space-between" $mt="20px">
            <CommonSwitchBtnCom curIndex={tabIndex} onClick={(index) => setTabIndex(index)}></CommonSwitchBtnCom>
            <AddNewBtnWrap onClick={() => dispatch(setOpenNewTicketWin(true))}>
              <AddNewSvgWrap></AddNewSvgWrap>
              <AddNewBtnLabelWrap $roobertSemiBold>New ticket</AddNewBtnLabelWrap>
            </AddNewBtnWrap>
          </Row>
        </TicketHeaderWrap>
        <TicketBodyWrap>
          <ListTopGradientWrap></ListTopGradientWrap>
          <ListBottomGradientWrap></ListBottomGradientWrap>
          <NewScrollBoxWrap>
            <StyledContainer $height="30px"></StyledContainer>
            {
              ticketList.map((item:any, index:number) => <StyledContainer key={index}>
                <TicketCardWrap >
                  <TicketCardLeftWrap>
                    <TicketIconSvgWrap></TicketIconSvgWrap>
                    <Column $ml="20px">
                      <Row $fontSize="14px" $lineHeight="1" $roobertRegular>
                        <StyledContainer>Ticket ID</StyledContainer>
                        <StyledContainer $ml="4px" $textDecoration="underline">{shortStr(item.ticketId+'', 8)}</StyledContainer>
                      </Row>
                      {/* <StyledContainer $fontSize="12px" $lineHeight="1" $mt="8px" $color="#767A7F">Jan 10, 2024 - 12:05AM</StyledContainer> */}
                    </Column>
                  </TicketCardLeftWrap>
                  <TicketCardRightWrap $justifyContent="space-between">
                    <Column>
                      <Row>
                        <HashHandlerItem certHash={item.hash} fontSize="14px" lineHeight="14px" showBrowser={false}></HashHandlerItem>
                        <ChainInfoWrap>
                          <StyledContainer $fontSize="14px" $lineHeight="14px" $fontWeight6 $roobertSemiBold>Chain: </StyledContainer>
                          <StyledContainer $fontSize="14px" $lineHeight="14px" $fontWeight5 $ml="8px">{getChainInfo(item.chain)['fullName']}</StyledContainer>
                          <CImage src={getChainInfo(item.chain)['imgUrl']} width="14px" height="14px" ml="12px"></CImage>
                        </ChainInfoWrap>
                      </Row>
                      <CommentBoxWrap $isComment={!!item.solution}>
                        <CommentSvgWrap></CommentSvgWrap>
                        <StyledContainer $ml="8px" $fontWeight5>Dev comments:</StyledContainer>
                        <StyledContainer $ml="8px" $mr="4px" $fontWeight4 $roobertRegular>{!!item.solution ? item.solution: 'N/A'}</StyledContainer>
                      </CommentBoxWrap>
                    </Column>
                    <StatusBarWrap $status={item.succeeded? 'solved' : 'pending'}>
                      {getStatusIcon(item.succeeded? 'solved' : 'pending')}
                      <StyledContainer>{item.succeeded? 'Solved' : 'Pending'}</StyledContainer>
                    </StatusBarWrap>
                  </TicketCardRightWrap>
                </TicketCardWrap>
              </StyledContainer>)
            }
          </NewScrollBoxWrap>
        </TicketBodyWrap>
      </OutWrap>
      <DrawerNewTicketCom open={openNewTicketWin} closeChange={(isClosed) => dispatch(setOpenNewTicketWin(isClosed))} onComplete={() => getTicketList()}></DrawerNewTicketCom>
  </TicketsPageWrap>
}

const TicketsPageWrap = styled(StyledContainer)`
    display: flex;
    min-height: 100vh;
    flex: 1;
`

const EmptyColumn = styled(StyledContainer)`
  flex: 1;

  @media screen and (min-width: 1920px) {
    flex: 1;
  }
  @media screen and (min-width: 1440px) and (max-width: 1920px) {
    flex: 1;
  }
  @media screen and (min-width: 1024px) and (max-width: 1440px) {
    flex: 1;
  }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    flex: none;
    width: 24px;    
  }
  @media screen and (max-width: 768px) {
    flex: none;
  }
`

const OutWrap = styled(StyledContainer)`
  flex: 9;

  background-color: ${({theme}) => theme.basicWhite};
  background-image: url(${ticketBgImg});
  background-position: right top;
  background-repeat: no-repeat;
  background-size: 35vw;
  box-sizing: border-box;
  position: relative;
`

const TicketHeaderWrap = styled(StyledContainer)`
  padding: 30px 40px 20px 40px;
  border-bottom: 1px dashed #CACCCE;
`

const TicketBodyWrap = styled(StyledContainer)`
  height: calc(100vh - 180px);
  position: relative;
`


// 新增按钮

const AddNewSvgWrap = styled(AddNewSvg)`
  width: 16px;
  height: 16px;
  transition: all 0.2s;
  rect, path {
    transition: all 0.2s;
  }
`
const AddNewBtnLabelWrap = styled(StyledContainer)`
  font-size:14px;
  line-height: 1;
  font-weight: 600;
  color: #4D1DF7;
  margin-left: 10px;
`

const AddNewBtnWrap = styled(RowCenter)`
  border-radius: 6px;
  border: 1px solid #4D1DF7;
  padding: 10px 16px;
  cursor: pointer;

  &:hover {
    background-color: #4D1DF7;
    ${AddNewSvgWrap} {
      rect, path {
        fill: #ffffff;
      }
    }
    ${AddNewBtnLabelWrap} {
      color: #ffffff;
    }
  }
`

// order card
const NewScrollBoxWrap = styled(ScrollBoxWrap)`
  padding-left: 40px;
  padding-right: 40px;
`

const TicketCardWrap = styled(Row)`
  border-radius: 6px;
  border: 1px solid #F2F2F2;
  box-shadow: 0px 2px 2px -2px rgba(24, 39, 75, 0.06), 0px 1px 2px 0px rgba(24, 39, 75, 0.08);
  margin-bottom: 10px;
`

const TicketCardLeftWrap = styled(RowCenter)`
  width: 245px;
  border-right: 1px dashed #DFE0E2;
  padding: 44px 20px 44px 20px;
  box-sizing: border-box;
`

const TicketIconSvgWrap = styled(TicketIconSvg)`
  width: 30px;
  height: 26px;
`

const TicketCardRightWrap = styled(Row)`
  flex: 1;
  padding: 25px 20px 25px 40px;
`

const svgStyle = () => {
  return css`
      width: 16px;
      height: 16px;
  `
}
const PendingIconSvgWrap = styled(PendingIconSvg)`
  ${svgStyle()}
`

const RightIconSvgWrap = styled(RightIconSvg)`
  ${svgStyle()}
`

const StatusBarWrap = styled(Row)<{$status: string}>`
  padding: 7px 8px;
  border-radius: 6px;

  &>div {
    font-size: 12px;
    line-height: 16px;
    margin-left: 8px;
  }

  ${
    ({$status}) => $status === 'pending' ? css`
      background-color: #FDFDD8;
      &>div {
        color: #B59800;
      }
    `:css`
      background-color: #EBFFEC;
      &>div {
        color: #00A708;
      }
    `
  }
`

const ChainInfoWrap = styled(Row)`
  padding: 12px 8px;
  border-radius: 6px;
  background-color: #F4F5F5;
  margin-left: 10px;
`

const CommentSvgWrap = styled(CommentSvg)`
  width: 14px;
  height: 14px;
`

const CommentBoxWrap = styled(Row)<{$isComment: boolean}>`
  font-size: 12px;
  line-height: 12px;
  margin-top: 18px;
  ${
    ({$isComment}) => $isComment ? css`
      &>div {
        color: #0A0A0A;
      }
      ${CommentSvgWrap} {
        rect, path {
          fill: #0A0A0A;
        }
      }
    ` : css`
      &>div {
        color: #B5B7BA;
      }
      ${CommentSvgWrap} {
        rect, path {
          fill: #B5B7BA;
        }
      }
    `
  }
`

export default TicketsPage